import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TablerArrowDown = _resolveComponent("TablerArrowDown")!
  const _component_TablerArrowUp = _resolveComponent("TablerArrowUp")!
  const _component_TablerArrowsSort = _resolveComponent("TablerArrowsSort")!
  const _component_StudioButton = _resolveComponent("StudioButton")!
  const _component_TooltipPopup = _resolveComponent("TooltipPopup")!

  return (_openBlock(), _createBlock(_component_TooltipPopup, null, _createSlots({
    trigger: _withCtx(() => [
      _createVNode(_component_StudioButton, {
        ref: "sortButtonRef",
        trackingId: _ctx.trackingId,
        variant: _ctx.buttonVariant,
        class: _normalizeClass({
          'tw-border-black': _ctx.isActive && _ctx.showBorder,
          'tw-border-transparent': !_ctx.showBorder
        }),
        size: "small",
        onClick: _ctx.handleClick
      }, {
        icon: _withCtx(() => [
          (_ctx.sortOrder === 'asc')
            ? (_openBlock(), _createBlock(_component_TablerArrowDown, {
                key: 0,
                class: "tw-h-4 tw-w-4"
              }))
            : (_ctx.sortOrder === 'desc')
              ? (_openBlock(), _createBlock(_component_TablerArrowUp, {
                  key: 1,
                  class: "tw-h-4 tw-w-4"
                }))
              : (_openBlock(), _createBlock(_component_TablerArrowsSort, {
                  key: 2,
                  class: "tw-h-4 tw-w-4"
                }))
        ]),
        _: 1
      }, 8, ["trackingId", "variant", "class", "onClick"])
    ]),
    _: 2
  }, [
    (_ctx.showTooltip)
      ? {
          name: "content",
          fn: _withCtx(() => [
            _createTextVNode("Sort")
          ]),
          key: "0"
        }
      : undefined
  ]), 1024))
}